var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "49px",
    viewBox: "0 0 44 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.7832559%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31C0EB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16D3AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.547437124,17.5732412 L4.48479335,9.32572249 C5.78948745,6.59280009 9.01869519,5.47684398 11.7229736,6.82433758 L19.7651758,10.8316231 C22.488327,12.1885207 23.6524404,15.5303361 22.3652959,18.2957767 C22.357674,18.3121524 22.349973,18.3284886 22.3421933,18.3447846 L18.4048371,26.5923033 C17.100143,29.3252257 13.8709352,30.4411818 11.1666568,29.0936882 L3.12445459,25.0864027 C0.401303377,23.7295052 -0.762810014,20.3876898 0.524334559,17.6222491 C0.531956449,17.6058734 0.539657397,17.5895373 0.547437124,17.5732412 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.1%",
    y: "-12.8%",
    width: "126.2%",
    height: "125.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.233660754   0 0 0 0 0.250401661   0 0 0 0 0.332795516  0 0 0 0.115848995 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEB31",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D316",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.34398904,7.31438756 L12.3652832,2.96349517 C15.0232692,1.52175636 18.3357795,2.58559267 19.7726994,5.34243971 L24.0010022,13.4547807 C25.4412431,16.2179994 24.4528828,19.6368055 21.7934377,21.0908981 C21.7882017,21.0937609 21.782961,21.0966149 21.7777158,21.0994601 L13.7564216,25.4503524 C11.0984356,26.8920913 7.7859253,25.8282549 6.34900541,23.0714079 L2.12070259,14.9590669 C0.680461711,12.1958483 1.66882201,8.77704207 4.32826711,7.32294956 C4.33350314,7.32008668 4.33874379,7.31723268 4.34398904,7.31438756 L4.34398904,7.31438756 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.9%",
    y: "-12.6%",
    width: "125.9%",
    height: "125.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.233660754   0 0 0 0 0.250401661   0 0 0 0 0.332795516  0 0 0 0.115848995 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.6225718%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC66",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB32B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.3356887,0.0426256053 L21.3391364,1.19964183 C24.3286302,1.58381609 26.4580307,4.4618792 26.0952854,7.62797571 C26.0946585,7.63344678 26.0940243,7.6389169 26.0933827,7.64438605 L25.0032501,16.9366689 C24.6326986,20.0952469 21.9188302,22.3407711 18.9353868,21.9573744 L9.93193916,20.8003582 C6.9424453,20.4161839 4.81304486,17.5381208 5.17579015,14.3720243 C5.17641698,14.3665532 5.17705121,14.3610831 5.17769282,14.355614 L6.26782546,5.06333106 C6.63837692,1.90475306 9.35224529,-0.340771131 12.3356887,0.0426256053 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-13.6%",
    width: "128.6%",
    height: "127.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.233660754   0 0 0 0 0.250401661   0 0 0 0 0.332795516  0 0 0 0.115848995 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2B2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9771072,1.71280889 L29.0953711,6.32921356 C31.798745,7.86647182 32.7566358,11.2501943 31.2348799,13.8869693 C31.2284909,13.8980396 31.2220625,13.9090874 31.2155947,13.9201125 L26.6866213,21.6403198 C25.1536693,24.2534302 21.7457185,25.12773 19.0556322,23.5980277 L10.9373683,18.981623 C8.23399438,17.4443647 7.27610365,14.0606423 8.79785951,11.4238673 C8.80424849,11.412797 8.81067692,11.4017492 8.81714469,11.390724 L13.3461181,3.67051674 C14.8790701,1.05740637 18.2870209,0.183106594 20.9771072,1.71280889 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.6%",
    y: "-12.8%",
    width: "125.1%",
    height: "125.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.233660754   0 0 0 0 0.250401661   0 0 0 0 0.332795516  0 0 0 0.115848995 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-15.3923077%",
    y1: "50%",
    x2: "147.955107%",
    y2: "29.2872997%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696CFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B992FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.0928673,7.50626338 L32.478531,14.3306171 C34.6112773,16.6098814 34.5145957,20.19226 32.2625867,22.3320837 C32.2474715,22.3464459 32.2322768,22.360723 32.2170034,22.3749142 L25.4644701,28.6489828 C23.2067568,30.7467212 19.6867463,30.615035 17.5707515,28.353673 L11.1850878,21.5293193 C9.05234148,19.250055 9.14902304,15.6676764 11.4010321,13.5278527 C11.4161473,13.5134904 11.4313419,13.4992134 11.4466154,13.4850222 L18.1991487,7.21095353 C20.456862,5.11321517 23.9768724,5.24490136 26.0928673,7.50626338 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-88.2%",
    y: "-47.1%",
    width: "251.8%",
    height: "251.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 7,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.552941176   0 0 0 0 0.490196078   0 0 0 0 1  0 0 0 0.221345061 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.285722787   0 0 0 0 0.268443182   0 0 0 0 0.665874094  0 0 0 0.308375219 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Starter-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Item-detail",
    transform: "translate(-25.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-UI-Elements/3.-Navigation/0.-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-UI-Elements/9.-Misc/Logo/Sign",
    transform: "translate(24.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    xlinkHref: "#path-14"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0cf693f44b0d5be3f71c349035eb2aa5.svg";
export { ForwardRef as ReactComponent };